import { CompanyAttributes } from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CompanyService } from "../../configuration/company/company.service.service";
import {
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import { ICreateRoute } from "./interfaces/create-route.interface";
import { IUpdateRoute } from "./interfaces/update-route.interface";
import { RouteService } from "./route.service";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { RouteAreaService } from "../route-area/route-area.service";
import { RouteGroupService } from "../route-group/route-group.service";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from 'app/utils/method';
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { RouteExport } from "./exports/route.export";
import { ROUTE_TITLE } from "./exports/route.constants";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: "app-routes",
  standalone: true,
  templateUrl: "./routes.component.html",
  styleUrl: "./routes.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    RouteExport
  ],
})
export class RouteComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "company", "statusId", "actions"];
  displayedColumnsI: string[] = ["days", "action", "status", "actions"];
  currentCreateRoute: ICreateRoute = this.initializeCreateRoute();
  currentUpdateRoute: RouteAttributes | undefined;

  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  routeGroupList: RouteGroupAttributes[] = [];
  routeAreaList: RouteAreaAttributes[] = [];

  daysList: { day: string; value: number }[] = [
    { day: "LUNES", value: 1 },
    { day: "MARTES", value: 2 },
    { day: "MIÉRCOLES", value: 3 },
    { day: "JUEVES", value: 4 },
    { day: "VIERNES", value: 5 },
    { day: "SÁBADO", value: 6 },
    { day: "DOMINGO", value: 7 },
  ];

  dataSource: RouteAttributes[] = [];
  searchQuery = "";
  totalItems = 0;
  pageSize = 50;
  pageIndex:number = 1;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("addModalItinerary") addModalItinerary!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;
  form : FormGroup;
  selectedStatuses: number[]=[];

  // Lazy loading flags
  loadFiltersData = false;
  companiesLoaded = false;
  routeAreasLoaded = false;
  routeGroupsLoaded = false;

  constructor(
    private readonly companyService: CompanyService,
    private readonly routeService: RouteService,
    private readonly routeAreasService: RouteAreaService,
    private readonly routeGroupsService: RouteGroupService,
    private readonly searchService: SearchService,
    public exportService: ExportService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private routExport: RouteExport,
    private fb: FormBuilder
  ) {
     this.form = this.fb.group({
      companyId: [],
    }); 
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateRoute(): ICreateRoute {
    return { code: "",name: "", companyId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  private fetchCompanies(): void {
    if (this.companiesLoaded) return;
    this.companiesLoaded = true;
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
    });
  }

  private fetchRouteArea(): void {
    if (this.routeAreasLoaded) return;
    this.routeAreasLoaded = true;
    this.routeAreasService.findToComboBox().subscribe((res) => {
      this.routeAreaList = res.data;
    });
  }

  private fetchRouteGroup(): void {
    if (this.routeGroupsLoaded) return;
    this.routeGroupsLoaded = true;
    this.routeGroupsService.findToComboBox().subscribe((res) => {
      this.routeGroupList = res.data;
    });
  }

  private ensureModalDataLoaded(): void {
    this.fetchCompanies();
    this.fetchRouteArea();
    this.fetchRouteGroup();
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    let filter: IFilters={
      companyId: this.form.get("companyId").value,
      status: this.selectedStatuses,
    }
    this.routeService
      .findAllWithCount(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof RouteAttributes {
    const validSortFields: (keyof RouteAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof RouteAttributes)
      ? (this.sort.active as keyof RouteAttributes)
      : "name";
  }

  private getSelectedCompanyCodes(selectedIds: string[]): number[] {
    return selectedIds.map(
      (id) =>
        this.companyList.find((company) => company._id.toString() === id)?.id
    );
  }

  onCompanySelectionChange(selectedIds: string[]): void {
    this.selectedCompanyIds = selectedIds;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          //this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }


  trackByFn(index: number, item: RouteAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.form.reset({companyId: null})
    this.findAllWithCount();
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }


  openCreateModal(): void {
    this.ensureModalDataLoaded();
    this.currentCreateRoute = this.initializeCreateRoute();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createRoute());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(routeArea: RouteAttributes): void {
    this.ensureModalDataLoaded();
    this.currentUpdateRoute = { ...routeArea,
      externalKeys: {
        code: routeArea?.externalKeys?.code ?? null,
        }
     };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
      // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateRoute(routeArea._id.toString()));
      this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createRoute(): void {
    this.routeService.create(this.currentCreateRoute).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateRoute(id: string): void {
    if (this.currentUpdateRoute) {
      const updatedRoute: IUpdateRoute = {
        companyId: this.currentUpdateRoute.company._id.toString(),
        ...this.currentUpdateRoute,
      };

      this.routeService.update(id, updatedRoute).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, routeArea: RouteAttributes): void {
    const originalStatusId = routeArea.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedRoute = {
      ...routeArea,
      companyId: this.currentUpdateRoute.company._id.toString(),
      statusId: updatedStatusId,
    };

    this.routeService.update(routeArea._id.toString(), updatedRoute).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        routeArea.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
      },
    });
  }

  openDeleteDialog(routeArea: RouteAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: routeArea, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(routeArea._id.toString()));
  }

  delete(id: string): void {
    this.routeService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  //exportar
  onExportButtonPressed() {
    if (!this.routExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: ROUTE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.routExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
